import ArrPopoutPanel from '../../../components/common/arr-popout-panel/ArrPopoutPanel';
import {Typography, Box} from '@mui/material';
import ArrTextField from '../../../components/common/arr-text-field/ArrTextField';
import {useState} from 'react';

const PopoutPanelDemo = () => {
  const [text, setText] = useState('');
  return (
    <div className="popout-panel-demo">
      <Typography component="h2" className="typo-text subhead2_size">
        Popout Panel Demo - {text}
      </Typography>
      <div className="panel">
        <ArrPopoutPanel
          title="Popout Demo"
          actionMenuItems={[
            {
              id: '1',
              label: 'Open in Wizard',
              onClick: () => console.log('open'),
            },
            {id: '2', label: 'Delete', onClick: () => console.log('Delete')},
            {
              id: '3',
              label: 'Save as Template',
              onClick: () => console.log('Save as Template'),
            },
          ]}
        >
          <Box sx={{padding: '1rem'}}>
            <Typography
              component="h3"
              className="typo-text subhead5_size"
              sx={{color: 'white'}}
            >
              Popout Content
            </Typography>
            <Typography
              component="p"
              className="typo-text body4_size"
              sx={{color: 'white'}}
            >
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Consectetur ducimus eaque doloremque sint fuga voluptatibus dolore
              illum repellat non enim expedita quia quas assumenda modi, illo,
              autem rerum molestias saepe.
            </Typography>
            <ArrTextField
              label="Demo Text"
              onChange={(e) => setText(e.target.value)}
              dataTestId="popout-panel-demo"
            />
          </Box>
        </ArrPopoutPanel>
      </div>
    </div>
  );
};

export {PopoutPanelDemo};
export default PopoutPanelDemo;
